module.exports = __webpack_public_path__ + "static/media/0036.92ea5fb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48103/Decors/Decors_white/0036.png
// module id = 883
// module chunks = 0